import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-gamedata-download-dialog',
  templateUrl: './gamedata-download-dialog.component.html',
  styleUrls: ['./gamedata-download-dialog.component.sass']
})
export class GamedataDownloadDialogComponent implements OnInit {
  buildVersion: string = '';
  environment: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit() {
    this.buildVersion = this.config.data?.buildVersion || '';
    this.environment = this.config.data?.environment || '';
  }

  selectFull() {
    this.ref.close('full');
  }

  selectLite() {
    this.ref.close('lite');
  }

  cancel() {
    this.ref.close(null);
  }
}

